import { History } from 'history';
import { pushAppRoute } from '../../data/domain/route-manager';
import { AppRoute } from '../../routes';
import { AppThunk } from '../actions';
import { DashboardActions } from '../actions/dashboard-actions';

export const DashboardThunks = {
    singleLocationFound: (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        history: History<any>,
        currentRoute: AppRoute,
        args: { locationId: string }
        // eslint-disable-next-line require-await, @typescript-eslint/require-await
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch({
            type: 'Dashboard/AutoRedirectBannerShown',
        });

        const getDestinationRoute = (): AppRoute | undefined => {
            if (currentRoute.type === 'OverviewOrganization') {
                return {
                    type: 'OverviewLocation',
                    locationId: args.locationId,
                };
            }

            if (currentRoute.type === 'DevicesOrganization') {
                return {
                    type: 'DevicesLocation',
                    locationId: args.locationId,
                };
            }

            if (currentRoute.type === 'TimelineOrganization') {
                return {
                    type: 'TimelineLocation',
                    locationId: args.locationId,
                };
            }

            return undefined;
        };

        const destinationAppRoute = getDestinationRoute();
        if (!destinationAppRoute) {
            return;
        }

        pushAppRoute(history, destinationAppRoute);
    },
  
    locationRefresh: (isRefresh: boolean): AppThunk => (dispatch): void => {
        dispatch(DashboardActions.locationRefreshNeeded(isRefresh));
    },
};
